<!-- <div class="file-upload">
    <button mat-raised-button color="primary" (click)="fileInput.click()">
        Upload File
    </button>
    <input #fileInput type="file" style="display: none" (change)="onFileSelected($event)" />
    <span *ngIf="fileName" class="file-name">Selected File: {{ fileName }}</span>
</div> -->

<div class="file-upload">
    <button mat-raised-button style="background: #405189; color: #fff;" (click)="fileInput.click()">
        Upload Mẫu
    </button>
    <input #fileInput type="file" accept=".xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel" style="display: none" (change)="onFileSelected($event)" />
    <span *ngIf="displayFileName && fileUrl" class="file-name txtfilenamecustom" (click)="downloadFile()">{{ displayFileName }}</span>
    <span *ngIf="displayFileName && !fileUrl" class="file-name">{{ displayFileName }}</span>
    <button *ngIf="displayFileName" class="btn-icon" style="margin-left: 8px; background: none; border: none; cursor: pointer; vertical-align: middle;" (click)="removeFile()" title="Xóa file">
        <i class="ti ti-trash" style="color: red; font-size: 18px;"></i>
    </button>
</div>